 <app-stepper #stepper [steps]="steps" localize="true" (activeStepChange)="activeStep = $event"></app-stepper>

 <div class="wide-bg d-flex flex-column align-items-center" [style.height]="'500px'" [style.background-image]="'url(' + bgImageUrl + ')'">
   <div style="width: 660px;">
     <div class="m-content">
       <div class="row">
         <div class="col-lg-12">
           <div class="form-block">
             <div>
               <h1 class="login-page-title accent-text"
                   style="font-size: 25px;">
                 {{steps[activeStep].title | dictionary}} - {{'STEP' | dictionary}}
                 {{activeStep + 1}}
               </h1>
             </div>
             <div class="form-group" style="font-size: 14px;padding-left: 5px;">
               <div class="subtitle"
                    *ngIf="steps[activeStep].id === 'REGISTER_NEW_ACCOUNT'">{{'WELCOME_TO_SYSTEM' | dictionary : clientCode }}
                 <div class="subtitle"
                      *ngIf="steps[activeStep].id === 'ACCOUNT_VERIFICATION'">{{'REGISTRATION_INVESTOR_STEP_2' | dictionary : clientCode }}
                 </div>
               </div>

               <div class="pt-0 pb-0" style="padding:0;">
                 <div class="login-block">
                   <div class="m-portlet__body">
                     <div [hidden]="steps[activeStep].id !== 'REGISTER_NEW_ACCOUNT'">
                       <div class="field-wrapper">
                         <div class="col-sm-4">{{'INVESTOR_ID' | dictionary}}
                           <span class="asterisk">*</span>
                         </div>
                         <input [(ngModel)]="userProfile.AccountNumber"
                                class="form-control home-login-input-text col-sm-8"
                                aria-describedby="emailHelp"/>
                       </div>
                       <div class="form-group">
                         <div class="col-sm-4">{{'PIN' | dictionary}}</div>
                         <input [type]="showPin ? 'text' : 'password'" [(ngModel)]="userProfile.PIN"
                                class="form-control home-login-input-text col-sm-8"
                                aria-describedby="emailHelp"/>
                         <i class="fas icon cursor-pointer eye-bg"
                            [pTooltip]="(!showPin ? 'SHOW_PIN' : 'HIDE_PIN' ) | dictionary"
                            [ngClass]=" {'fa-eye' : !showPin, 'fa-eye-slash' : showPin }"
                            (click)="showPin = !showPin"></i>
                         <small class="form-text text-end small-note-text">
                           {{'ENTER_THE_PIN_THAT_WAS_PROVIDED' | dictionary}}
                         </small>
                         <small class="form-text text-end small-note-text">
                           {{'IF_YOU_DO_NOT_HAVE_YOUR_PIN' | dictionary}}
                         </small>
                       </div>
                     </div>

                     <div [hidden]="steps[activeStep].id !== 'ACCOUNT_VERIFICATION'">
                       <div class="field-wrapper">
                         <div class="col-sm-4">{{'TAX_ID_SOC_SEC' | dictionary}}
                           <span class="asterisk">*</span>
                         </div>
                         <input [(ngModel)]="userProfile.TaxId" [type]="!showTaxId ? 'password' : 'text'"
                                class="form-control home-login-input-text col-sm-8"
                                aria-describedby="emailHelp"/>
                         <i class="fas icon cursor-pointer eye-bg"
                            [pTooltip]="(!showTaxId ? 'SHOW_TAX_ID_SOC_SEC' : 'HIDE_TAX_ID_SOC_SEC' ) | dictionary"
                            [ngClass]=" {'fa-eye' : !showTaxId, 'fa-eye-slash' : showTaxId }"
                            (click)="showTaxId = !showTaxId"></i>
                       </div>
                       <div class="field-wrapper">
                         <div class="col-sm-4">{{'ZIP_CODE' | dictionary}}
                           <span class="asterisk">*</span>
                         </div>
                         <input [(ngModel)]="userProfile.Zip"
                                class="form-control home-login-input-text col-sm-8"
                                aria-describedby="emailHelp"/>
                       </div>
                     </div>

                     <div [hidden]="steps[activeStep].id !== 'CHALLENGE_QUESTIONS'">
                       <div>
                         <h6 class="text-center small-note-text">
                           {{'REGISTRATION_QUESTIONS_AND_ANSWERS' | dictionary}}
                         </h6>
                       </div>

                       <div class="field-wrapper">
                         <div class="col-sm-4">{{'SECURITY_QUESTION'| dictionary}}
                           <span class="asterisk">*</span>
                         </div>
                         <select #dropDownStatic
                                 class="form-control security-question-dropdown col-sm-8"
                                 [(ngModel)]="securityQuestionAnswer.SecQuestionCode1">
                           <option value=""></option>
                           <option *ngFor="let data of questionList"
                                   [ngValue]="data.SecQuestionCode">
                             {{data.SecQuestionText}}
                           </option>
                         </select>
                       </div>
                       <div class="field-wrapper">
                         <div class="col-sm-4">{{'ANSWER' | dictionary}}
                           <span class="asterisk">*</span>
                         </div>
                         <input [(ngModel)]="securityQuestionAnswer.SecAnswerText1"
                                class="form-control home-login-input-text col-sm-8"
                                aria-describedby="emailHelp"/>
                       </div>

                       <div class="field-wrapper">
                         <div class="col-sm-4">{{'SECURITY_QUESTION'| dictionary}}
                           <span class="asterisk">*</span>
                         </div>
                         <select #dropDownStatic
                                 class="form-control security-question-dropdown col-sm-8"
                                 [(ngModel)]="securityQuestionAnswer.SecQuestionCode2">
                           <option value=""></option>
                           <option *ngFor="let data of questionList"
                                   [ngValue]="data.SecQuestionCode">
                             {{data.SecQuestionText}}
                           </option>
                         </select>
                       </div>
                       <div class="field-wrapper">
                         <div class="col-sm-4">{{'ANSWER' | dictionary}}
                           <span class="asterisk">*</span>
                         </div>
                         <input [(ngModel)]="securityQuestionAnswer.SecAnswerText2"
                                class="form-control home-login-input-text col-sm-8"
                                aria-describedby="emailHelp"/>
                       </div>
                       <div class="field-wrapper">
                         <div class="col-sm-4">{{'SECURITY_QUESTION'| dictionary}}
                           <span class="asterisk">*</span>
                         </div>
                         <select #dropDownStatic
                                 class="form-control security-question-dropdown col-sm-8"
                                 [(ngModel)]="securityQuestionAnswer.SecQuestionCode3">
                           <option value=""></option>
                           <option *ngFor="let data of questionList"
                                   [ngValue]="data.SecQuestionCode">
                             {{data.SecQuestionText}}
                           </option>
                         </select>
                       </div>
                       <div class="field-wrapper">
                         <div class="col-sm-4">{{'ANSWER' | dictionary}}
                           <span class="asterisk">*</span>
                         </div>
                         <input [(ngModel)]="securityQuestionAnswer.SecAnswerText3"
                                class="form-control home-login-input-text col-sm-8"
                                aria-describedby="emailHelp"/>
                       </div>
                     </div>

                     <div [hidden]="steps[activeStep].id !== 'USER_PROFILE'">

                       <!-- <div class="field-wrapper">
                         <div class="col-sm-4">{{'USERNAME' | dictionary}}
                           <span class="asterisk">*</span>
                         </div>
                         <input [(ngModel)]="userProfile.UserId" (input)="toUpperCaseInput($event)" (blur)="validateUserName()"
                                class="form-control home-login-input-text col-sm-8"  maxlength="50"
                                />
                       </div> -->
                       <!-- <div class="field-wrapper">
                         <div class="col-sm-4">{{'CREATE_PASSWORD' | dictionary}}
                           <span class="asterisk">*</span>
                         </div>
                         <input [(ngModel)]="userProfile.Password" [type]="showPassword ? 'text' : 'password'"
                                class="form-control home-login-input-text col-sm-8"
                                aria-describedby="emailHelp"/>
                         <i class="fas icon cursor-pointer eye-bg"
                            [pTooltip]="(!showPassword ? 'SHOW_PASSWORD' : 'HIDE_PASSWORD' ) | dictionary"
                            [ngClass]=" {'fa-eye' : !showPassword, 'fa-eye-slash' : showPassword }"
                            (click)="showPassword = !showPassword"></i>
                       </div> -->
                       <!-- <div class="field-wrapper">
                         <div class="col-sm-4">{{'CONFIRM_PASSWORD' | dictionary}}
                           <span class="asterisk">*</span>
                         </div>
                         <input [(ngModel)]="userProfile.ConfirmPassword"
                                [type]="showPasswordConfirmation ? 'text' : 'password'"
                                (paste)="preventPaste($event)"
                                class="form-control home-login-input-text col-sm-8"
                                aria-describedby="emailHelp"/>
                         <i class="fas icon cursor-pointer eye-bg"
                            [pTooltip]="(!showPasswordConfirmation ? 'SHOW_PASSWORD' : 'HIDE_PASSWORD' ) | dictionary"
                            [ngClass]=" {'fa-eye' : !showPasswordConfirmation, 'fa-eye-slash' : showPasswordConfirmation }"
                            (click)="showPasswordConfirmation = !showPasswordConfirmation"></i>
                       </div> -->
                       <div class="field-wrapper">
                         <div class="col-sm-4">{{'EMAIL_ADDRESS' | dictionary}}
                           <span class="asterisk">*</span>
                         </div>
                         <input [(ngModel)]="userProfile.EmailAddress"
                                class="form-control home-login-input-text col-sm-8"
                                aria-describedby="emailHelp"/>
                       </div>

                       <div class="field-wrapper">
                         <div class="col-sm-4">{{'CONFIRM_EMAIL_ADDRESS' | dictionary}}
                           <span class="asterisk">*</span>
                         </div>
                         <input [(ngModel)]="userProfile.ConfirmEmailAddress"
                                class="form-control home-login-input-text col-sm-8"
                                aria-describedby="emailHelp"
                                (paste)="preventPaste($event)"
                         />
                       </div>

                       <div class="checkboxes-wrapper">
                         <div>
                           <input id="electronicMailAgreed" name="electronicMailAgreed" type="checkbox"
                                  [(ngModel)]="userProfile.ElectronicMailAgreed">
                           <label
                             for="electronicMailAgreed">{{'CHECK_TO_RECEIVE_ELECTRONIC_DELIVERY' | dictionary}}</label>
                         </div>

                         <div>
                           <input type="checkbox"
                                  [(ngModel)]="userProfile.TermsAndConditionAgreed">
                           <label class="underline" (click)="showTerms()"
                           >{{'I_HAVE_READ_AND_AGREE' | dictionary}}</label>
                         </div>
                       </div>

                     </div>

                   </div>
                 </div>
               </div>
             </div>
             <div class="form-group mt-10 text-center">
               <button *ngIf="activeStep  !== steps.length - 1" (click)="continue()"
                       class="button-1">
                 {{'CONTINUE' | dictionary}}
               </button>
               <button *ngIf="activeStep === steps.length - 1" (mousedown)="tryScheduleSave()"
                       class="button-1">
                 {{'SAVE' | dictionary}}
               </button>
               <button (mousedown)="cancel()"
                       class="ml-15 button-1">
                 {{'CANCEL' | dictionary}}
               </button>
             </div>

           </div>
           <div class="col-lg-3">
           </div>
         </div>
       </div>
     </div>
   </div>




   <app-pop-up-dialog [Message]="alertMessage" [Display]="display" (DisplayBack)="onClosePopup()">
   </app-pop-up-dialog>

   <app-pop-up-confirmation [cancelButton]="'CONTINUE_WITH_FURTHER_VERIFICATION'" [confirmButton]="'TRY_AGAIN'"
                            [Message]="alertMessage" [Display]="displayConfirmationPopup"
                            (DisplayBack)="onConfirm($event)"></app-pop-up-confirmation>


   <p-dialog [(visible)]="isRegistrationCompleted" [modal]="true" [resizable]="false" [focusOnShow]="true"
             class="forgotpasswordemaillink" (onHide)="navigateToLogin()">
     <div class="dialog-wrapper">
       <div class="col-lg-12 text-center">
         <!-- <h3>{{'REGISTRATION_COMPLETE' | dictionary}}</h3> -->
          <div style="font-size: 12pt; font-weight: bold;">Registration Next Steps:</div>
          <div style="font-size: 11pt;">You will now receive two emails from Vistra Fund. The first is to Verify your email address, please open that email and Verify your email by clicking the “Verify Your Account” button. The second email you receive from Vistra Fund will ask you to “Reset Your Password”. Please click the “Reset my Password” link to establish your password for the site. Once established you will be taken back to the login screen and can “Sign In” using the email address and password you have established.</div>
       </div>
     </div>
    <ng-template pTemplate="footer">
       <button class="button-1" type="button" (click)="navigateToLogin()">{{'CLOSE' | dictionary}}</button>
    </ng-template>
   </p-dialog>

 </div>
